__turbopack_context__.v({
  "additionalInfo": "eMPhsa_additionalInfo",
  "additionalInfoText": "eMPhsa_additionalInfoText",
  "buttonContainer": "eMPhsa_buttonContainer",
  "detailsList": "eMPhsa_detailsList",
  "minOrderValueMissing": "eMPhsa_minOrderValueMissing",
  "modalContent": "eMPhsa_modalContent",
  "orderNumberText": "eMPhsa_orderNumberText",
});
